var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('the-wrapper',{class:_vm.$style.rowData,attrs:{"isSpinner":_vm.isSpinner}},[_c('org-details-company'),_c('br'),_c('br'),_c('org-details-customer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }